window.vm = {}
window.addClickCounter = 0;

window.addEventListener('DOMContentLoaded', () => {

  // Store-specific settings rendered by snippets/global-cart.liquid (theme settings > Fulfillment).
  // 'legacy' routes between the Oregon and Nationwide stores; 'shipped' and 'pickup' check out on this store.
  const cartConfig = window.westwardCart || { fulfillmentMode: 'legacy', companionVariantId: null, clubs: {} };
  // Hidden line-item property marking the lines the cart auto-added for a membership (the companion
  // and the per-tier welcome gifts), so a customer's own purchase of the same variant is never
  // removed or treated as one of them.
  const COMPANION_PROPERTY = '_membership_companion';
  const isLegacyFulfillment = cartConfig.fulfillmentMode === 'legacy';
  // Cart attribute set by the staff "no bottle" link (?nobottle=<code> on the club page; the code is a
  // theme setting that only the club-tiers section renders, into window.westwardNoBottleCode):
  // the cart then skips the membership companion. It is saved on the order; welcome gifts are unaffected.
  const NO_BOTTLE_ATTRIBUTE = 'No bottle link';

  if (window.location.hash.substr(1) == "cart")
	{
      document.querySelector('body').classList.add('open-cart');
	}

  (function() {
    // Observe for changes in PDP - Add to Cart
    const addToCartBttn = document.getElementById('add');
    if(addToCartBttn){
      addToCartBttn.addEventListener('click', (event) => { window.addClickCounter = window.addClickCounter + 1; });
      let mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {          
          if (!mutation.target.disabled) {
            globalCart.fetchCartData();
            if (window.addClickCounter > 0)
              {
                document.querySelector('.cart-link__bttn').click();
                window.addClickCounter = 0;
              }            
          }
        });
      });

      const mutationAttr = {
        attributes: true,
        characterData: true
      };

      mutationObserver.observe(addToCartBttn, mutationAttr);
    }
    
    //Observe for changes in Collection Quick Add
   	const buttons = document.getElementsByClassName('quick-add-button');
    Array.from(buttons).forEach((addButton) => {
      let mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (!mutation.target.disabled) {
            globalCart.fetchCartData();
            document.querySelector('.cart-link__bttn').click();
          }
        });
      });

      const mutationAttr = {
        attributes: true,
        characterData: true
      };

      mutationObserver.observe(addButton, mutationAttr);
    });
  })();

  const globalCart = new Vue({
    el: '.global-cart',
    delimiters: ['${', '}'],
    data: {
      cartData: null,
      cartOpen: document.querySelector('body').classList.contains('open-cart'),
      oregonOnly: null,
      isBadgeSet: false,
      giftNote: null,
      hasClubProducts: false,
      hasGiftSubscriptions: false,
      hasNonGiftSubscriptions: false,
      companionVariantId: cartConfig.companionVariantId,
      welcomeGifts: cartConfig.welcomeGifts || {},
      // Variant ids whose auto-add failed (missing on this store, sold out…); not retried.
      autoAddFailed: {},
      autoRemoveFailed: false,
      unentitledRemovalFailed: false,
      busy: false
    },
    mounted() {
      if (isLegacyFulfillment && this.get_cookie('clear_cart'))
      {
         this.clearCart();
         this.delete_cookie('clear_cart','/','westwardwhiskey.com');
      }
      else
      {
        this.applyNoBottleLink().then(() => this.fetchCartData());
      }
      
      if (isLegacyFulfillment && sessionStorage.oregonOnly != null)
      {
        this.oregonOnly = sessionStorage.oregonOnly == "true";
        this.isBadgeSet = true;
      }
      vm.cart = this;
    },
/*    watch: {
      oregonOnly(val, oldVal) {
        if (this.loadedDefaults == true)
        {
          console.log('changed',val,this.oregonOnly);
          sessionStorage.oregonOnly = val;
          this.isBadgeSet = true;
        }
      }
    },
*/
    methods: {
      fetchCartData() {
        fetch('/cart.js')
          .then((res) => res.json())
          .then(async (data) => {
          	await this.updateItemTags(data);
            // Keep the membership companion item in sync with the club subscription before rendering.
            // reconcileCompanionItem triggers another fetchCartData, so leave `busy` set for it to clear.
            if (await this.reconcileCompanionItem(data)) { return; }
            // Drop tier-exclusive products the shopper only had access to through a membership that left the cart.
            if (await this.removeUnentitledItems(data)) { return; }
            this.updateCartCount(data.item_count);
            this.cartData = data;
            this.hasClubProducts = data.items.filter(i => this.isClubItem(i)).length > 0;
            this.hasGiftSubscriptions = data.items.filter(i => i.tags.includes('gift-subscription')).length > 0;
            this.hasNonGiftSubscriptions = data.items.filter(i => !i.tags.includes('gift-subscription') && !this.isCompanionItem(i)).length > 0;
            this.busy = false;
          })
          .catch((error) => {
            console.log('ERROR:', error.message);
            this.busy = false;
          });
      },
      changeLine(id, qty) {
        this.busy = true;
        const body = {
          id: id.toString(),
          quantity: qty
        };
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        };

        fetch('/cart/change.js', config)
          .then((res) => res.json())
          .then((data) => {
            this.fetchCartData();
            //this.cartData = data;
            //this.updateCartCount(data.item_count);
          })
          .catch((error) => {
            const errorMessage = error.message;
            console.log('ERROR:', errorMessage);
            this.busy = false;
          });
      },
      clearCart() {
        this.busy = true;
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        };

        fetch('/cart/clear.js', config)
          .then((res) => res.json())
          .then((data) => {
            this.fetchCartData();
          })
          .catch((error) => {
            const errorMessage = error.message;
            console.log('ERROR:', errorMessage);
            this.busy = false;
          });
      },
      updateCartCount(count){
        const cartCount = document.querySelector('.cart__count');
        if (cartCount)
        {
        	cartCount.innerText = `(${count})`;
        }
      },
    isOregonOnly(flag) {
      this.oregonOnly = flag;
      sessionStorage.oregonOnly = this.oregonOnly;
      this.isBadgeSet = true;
    },
    onBadgeSwitch(event) {
      this.oregonOnly = event.target.checked;
      sessionStorage.oregonOnly = this.oregonOnly;
      this.isBadgeSet = true;
    },
    get_cookie(name){
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
  },
  delete_cookie(name, path, domain) {
  if( this.get_cookie(name) ) {    
    document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
  },
    async checkout(domain,customer_id,customer_email) {
      if (!isLegacyFulfillment) {
        const paramNote = this.giftNote != null ? `?note=${encodeURIComponent(this.giftNote)}` : '';
        window.location = '/checkout' + paramNote;
        return;
      }
    	let baseURL = "https://westward-whiskey-nation.myshopify.com";
    	if (!this.oregonOnly && !this.hasClubProducts && !this.hasGiftSubscriptions)
    	{
    		const cartItems = this.cartData.items.filter(i => i.tags.includes('B:SS'));
    		let cartParams = new Array();            
            cartItems.forEach(item => {
    			let cartItem = {};
    			cartItem.id = item.tags.filter(t => t.includes('WW:'))[0].split(':')[1];
				cartItem.quantity = item.quantity;
    			let sp = item.tags.filter(t => t.includes('SP:'));
    			if (sp.length > 0)
   				{
    				cartItem.selling_plan = sp[0].split(':')[1];
                  	cartItem.quantity = 1;
  				}
    			cartParams.push(cartItem);
          	});
			
			// let data = { items: cartParams };
			// if (this.giftNote != null)
      //       {
      //       	data.note = this.giftNote;
      //       }
			//window.location.href = baseURL + "/pages/cart?add=" + encodeURIComponent(JSON.stringify(data));
			let productString = cartParams.map(product => `${product.id}:${product.quantity}`).join(',');
      let noteParam = "";
      if (this.giftNote != null)
      {
        noteParam = `?note=`+ encodeURIComponent(this.giftNote);
      }
			window.location.href = baseURL + "/cart/" + productString + noteParam;

  		}
    	else
    	{
  		var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];      	
        // The membership companion always goes through to the Oregon checkout, whatever its tags.
        let excludedIds = this.cartData.items.filter(i => i.tags.includes('B:SS') && !i.tags.includes('B:OO') && !this.isCompanionItem(i)).map(i => i.key);
        if (!this.oregonOnly)
        {
          	// Club memberships may be mixed with Select States items; gift subscriptions still can't be mixed.
          	excludedIds = this.cartData.items.filter(i => !(this.isClubItem(i) || i.tags.includes('gift-subscription') || this.isCompanionItem(i)) &&
          	  (this.hasGiftSubscriptions || !i.tags.includes('B:SS'))).map(i => i.key);
            // const giftIds = this.cartData.items.filter(i => !i.tags.includes('gift-subscription')).map(i => i.variant_id);
            // if (giftIds && giftIds.length > 0)
            //   {
            //     if (excludedIds)
            //       {
            //         excludedIds = [...excludedIds, ...giftIds];
            //       }
            //       else
            //       {
            //         excludedIds = giftIds;
            //       }
            //   }
        }
        if (excludedIds && excludedIds.length) {
           await this.asyncForEach(excludedIds, async id => {
          	  await fetch('/cart/change.js', {
                method: 'POST',
                headers: {                  
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({id: id.toString(), quantity: 0})
              });
          });
          }
          
          var paramNote = this.giftNote != null ? `?note=${encodeURIComponent(this.giftNote)}` : '';
          window.location = '/checkout' + paramNote;
		}
  	},
      // An auto-added membership line: the companion or a welcome gift.
      isCompanionItem(item) {
        return !!item && !!item.properties && !!item.properties[COMPANION_PROPERTY] &&
          this.autoItemVariantIds().includes(item.variant_id);
      },
      // The welcome gift note for a Waypoint / Founders sign-up line ('' for any other line).
      welcomeGiftNote(item) {
        if (!this.isClubItem(item)) { return ''; }
        const notes = cartConfig.welcomeGiftNotes || {};
        const tier = ['waypoint', 'founders'].find(t => {
          const club = (cartConfig.clubs || {})[t];
          return club && club.variantId && club.variantId === item.variant_id;
        });
        return (tier && notes[tier]) || '';
      },
      // Marks the cart when the club page was opened with the staff "no bottle" link. Resolves either way.
      applyNoBottleLink() {
        const code = (window.westwardNoBottleCode || '').trim();
        const param = new URLSearchParams(window.location.search).get('nobottle');
        if (!code || param !== code) { return Promise.resolve(); }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [NO_BOTTLE_ATTRIBUTE]: 'yes' } })
        }).catch(error => console.log('ERROR:', error.message));
      },
      autoItemVariantIds() {
        return [this.companionVariantId, this.welcomeGifts.waypoint, this.welcomeGifts.founders].filter(Boolean);
      },
      // Variants the cart should hold for the memberships in it: the companion for any membership,
      // plus a tier's welcome gift while that tier's sign-up product is in the cart.
      wantedAutoItems(items, attributes) {
        const clubLines = items.filter(i => this.isClubItem(i));
        if (!clubLines.length) { return []; }
        const skipCompanion = !!attributes && attributes[NO_BOTTLE_ATTRIBUTE] === 'yes';
        const wanted = this.companionVariantId && !skipCompanion ? [this.companionVariantId] : [];
        ['waypoint', 'founders'].forEach(tier => {
          const club = (cartConfig.clubs || {})[tier];
          const gift = this.welcomeGifts[tier];
          if (gift && club && club.variantId && clubLines.some(i => i.variant_id === club.variantId)) {
            wanted.push(gift);
          }
        });
        return wanted;
      },
      // A club membership is a Recharge subscription line (tag `recharge-subscription-product`) or a
      // Big Thirst sign-up product (tag `bts-signup`), NOT any product with "club" in its handle
      // (club-branded bottles share that word).
      // The companion line is excluded so reconcileCompanionItem can still remove it once the membership leaves.
      isClubItem(item) {
        return !!item && !this.isCompanionItem(item) && !!item.tags &&
          (item.tags.includes('recharge-subscription-product') || item.tags.includes('bts-signup'));
      },
      // Ensures the (irremovable) auto-added lines mirror the club memberships in the cart:
      // each wanted companion / welcome gift is added, and any that is no longer wanted is removed.
      // Returns true when it changed the cart (a fresh fetchCartData was triggered).
      async reconcileCompanionItem(data) {
        if (!data || !data.items) { return false; }
        const wanted = this.wantedAutoItems(data.items, data.attributes);
        const lines = data.items.filter(i => this.isCompanionItem(i));
        // A failed add (variant missing on this store, sold out…) isn't retried, or every fetch would loop.
        const toAdd = wanted.filter(id => !this.autoAddFailed[id] && !lines.some(l => l.variant_id === id));
        const toRemove = lines.filter(l => !wanted.includes(l.variant_id));
        // $0 welcome gifts the shopper added themselves (no hidden property) are removed too: they only
        // come with a membership. A gift sold at a regular price (made free by a discount) and the
        // companion are kept when bought on their own.
        const giftIds = [this.welcomeGifts.waypoint, this.welcomeGifts.founders].filter(Boolean);
        if (!this.autoRemoveFailed) {
          toRemove.push(...data.items.filter(i => giftIds.includes(i.variant_id) && !this.isCompanionItem(i) && i.original_price === 0));
        }
        if (!toAdd.length && !toRemove.length) { return false; }
        for (const id of toAdd) {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, quantity: 1, properties: { [COMPANION_PROPERTY]: 'true' } })
          });
          if (!res.ok) {
            this.autoAddFailed[id] = true;
            console.error('Could not add the membership companion / welcome gift variant', id);
          }
        }
        if (toRemove.length) {
          const updates = {};
          toRemove.forEach(l => { updates[l.key] = 0; });
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          // A failed removal isn't retried, or every fetch would loop.
          if (!res.ok) {
            this.autoRemoveFailed = true;
            console.error('Could not remove membership companion / welcome gift lines', Object.keys(updates));
          }
        }
        this.fetchCartData();
        return true;
      },
      // Club tier a product requires (mirrors sections/main-product.liquid): club-exclusive alone = 1,
      // + store:waypoint = 2, + store:cask = 3; 0 when it isn't gated.
      requiredClubRank(item) {
        const tags = item.tags || [];
        if (!tags.includes('club-exclusive')) { return 0; }
        if (tags.includes('store:cask')) { return 3; }
        if (tags.includes('store:waypoint')) { return 2; }
        return 1;
      },
      // Tier the shopper has access to: their own club tags, or the highest club membership in the cart.
      clubAccessRank(items) {
        const clubs = Object.values(cartConfig.clubs || {});
        return items.reduce((rank, item) => {
          const club = clubs.find(c => c.variantId && c.variantId === item.variant_id);
          return club ? Math.max(rank, club.rank) : rank;
        }, cartConfig.customerClubRank || 0);
      },
      // Removes gated products whose tier the shopper no longer has access to (e.g. the membership
      // that unlocked them was removed). Returns true when it changed the cart (a fresh fetchCartData was triggered).
      async removeUnentitledItems(data) {
        if (!data || !data.items) { return false; }
        const rank = this.clubAccessRank(data.items);
        const updates = {};
        data.items
          .filter(i => !this.isClubItem(i) && !this.isCompanionItem(i) && this.requiredClubRank(i) > rank)
          .forEach(i => { updates[i.key] = 0; });
        // A failed removal isn't retried, or every fetch would loop.
        if (!Object.keys(updates).length || this.unentitledRemovalFailed) { return false; }
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!res.ok) {
          this.unentitledRemovalFailed = true;
          console.error('Could not remove club-exclusive items the shopper has no access to', Object.keys(updates));
        }
        this.fetchCartData();
        return true;
      },
      async updateItemTags(data) {
        if (data && data.items) {
          // Fetch every line item's tags concurrently instead of one-at-a-time —
          // the sequential version was the main source of the cart's lag.
          await Promise.all(data.items.map(async (item) => {
            const product = await fetch(`/products/${item.handle}.js`).then((res) => res.json());
            item.tags = product.tags;
          }));
        }
      },
      async asyncForEach(array, callback) {
        for (let index = 0; index < array.length; index++) {
          await callback(array[index], index, array);
        }
      }
    },
    filters: {
      formatPrice(price) {
        return (price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      resizeImg(src) {
        const n = src?.lastIndexOf('.');
        if (n)
        {
          return `${src.substring(0, n)}_200x${src.substring(n)}`  
        }
        return src;
      }
    }
  });
  
  function checkCart(club) {
    const { variantId, sellingPlanId } = cartConfig.clubs[club] || {};
    if (!variantId || !sellingPlanId) {
      console.error(`Club sign-up product for "${club}" not found. Check the handle in theme settings > Fulfillment.`);
      return;
    }
    vm.cart.busy = true;
    $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(data) {
            if (data.items && data.items.length) {
              // Detect an existing membership by its subscription selling plan (tags aren't
              // loaded on this raw /cart.js response). Club-branded bottles are one-time buys.
              const isInCart = data.items.find(item => item.selling_plan_allocation)

              if (isInCart) {
                vm.cart.fetchCartData();
                document.querySelector('.cart-link__bttn').click();
              } else {
                addItemToCart(variantId, 1, sellingPlanId)
            }
            } else {
              addItemToCart(variantId, 1, sellingPlanId)
            }
          },
          error: function() { vm.cart.busy = false; }
      });
  }

  function addItemToCart(variant_id, qty, sellingPlanId) {
    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": sellingPlanId
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        vm.cart.fetchCartData();
        document.querySelector('.cart-link__bttn').click();
      },
      error: function() { vm.cart.busy = false; }
    });
  }

  // Explorer Club - Sign up (with price)
  $('.add_to_explorer').click(function(e){
    e.preventDefault();
    checkCart('explorer');
  });

  // Founders Club - Sign up (with price)
  $('.add_to_cask').click(function(e){
    e.preventDefault();
    checkCart('founders');
  });

  // Waypoint Club - Sign up (with price)
  $('.add_to_waypoint').click(function(e){
    e.preventDefault();
    checkCart('waypoint');
  });

})